var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-panel',{attrs:{"tabs":[
   { name: 'Informações do ponto', component: _vm.StopInfoTab, props: { stop: _vm.deliveryStop, driver: _vm.driver, trackingCode: _vm.trackingCode } },
   { name: 'Comprovante do serviço', component: _vm.PodInfoTab, props: { pod: _vm.pod } } ]}})}
var staticRenderFns = []

export { render, staticRenderFns }